export class Entity<T>{
    id:T
}